<div class="auth-wrapper">

	<!-- Painel ilustrativo: fundo animado + card do ecossistema -->
	<div class="auth-illustration">
		<ul class="circles">
			<li><img src="assets/images/login-icons/email.svg" alt=""></li>
			<li><img src="assets/images/login-icons/sms.svg" alt=""></li>
			<li><img src="assets/images/login-icons/headset.svg" alt=""></li>
			<li><img src="assets/images/login-icons/phone.svg" alt=""></li>
			<li><img src="assets/images/login-icons/contact.svg" alt=""></li>
			<li><img src="assets/images/login-icons/chat.svg" alt=""></li>
			<li><img src="assets/images/login-icons/email.svg" alt=""></li>
			<li><img src="assets/images/login-icons/sms.svg" alt=""></li>
			<li><img src="assets/images/login-icons/phone.svg" alt=""></li>
			<li><img src="assets/images/login-icons/headset.svg" alt=""></li>
		</ul>

		<div class="info-block">
			<h2 class="info-title" [innerHTML]="'loginInfo.tituloDestaque' | translate"></h2>
			<p class="info-desc">{{ 'loginInfo.jornadaDescricao' | translate }}</p>
			<div class="info-cards">
				<div class="info-mini-card">
					<img src="assets/images/login-icons/crm.svg" alt="">
					<span>{{ 'loginInfo.item1' | translate }}</span>
				</div>
				<div class="info-mini-card">
					<img src="assets/images/login-icons/gateway.svg" alt="">
					<span>{{ 'loginInfo.item2' | translate }}</span>
				</div>
				<div class="info-mini-card">
					<img src="assets/images/login-icons/dashboard.svg" alt="">
					<span>{{ 'loginInfo.item3' | translate }}</span>
				</div>
				<div class="info-mini-card">
					<img src="assets/images/login-icons/channels.svg" alt="">
					<span>{{ 'loginInfo.item4' | translate }}</span>
				</div>
			</div>
		</div>
	</div>

	<!-- Painel do formulário -->
	<div class="auth-panel">
		<div class="auth-panel-header">
			<img class="brand-logo-sm" *ngIf="AppConfig?.theme == 'light'" src="image/talklogomedium_{{logo}}.png"
				alt="Logo">
		</div>

		<div class="auth-panel-body">
			<div class="auth-card">

				<div class="auth-mobile-logo">
					<img *ngIf="AppConfig?.theme == 'light'" src="image/talklogomedium_{{logo}}.png" alt="Logo">
				</div>

				<h2 class="auth-title">{{ 'login.esqueciMinhaSenha' | translate }}</h2>
				<p class="auth-subtitle">{{ 'login.recuperarSenhaSubtitulo' | translate }}</p>

				<!-- Banner de instrução -->
				<div class="info-banner">
					{{ 'login.esqueciMinhaSenhaInstrucao' | translate }}
				</div>

				<form (ngSubmit)="recuperarSenha()" #forgotPasswordForm="ngForm">
					<mat-form-field appearance="outline">
						<mat-label>{{ 'login.email' | translate }}</mat-label>
						<input type="email" name="email" id="email-input" matInput
							placeholder="{{ 'login.email' | translate }}" [(ngModel)]="email" required email
							#emailInput="ngModel">
					</mat-form-field>

					<div class="error-message"
						*ngIf="error || (emailInput.invalid && emailInput.touched)">
						<mat-icon class="error-icon">error_outline</mat-icon>
						<span class="text-danger" *ngIf="emailInput.errors?.['required'] && emailInput.touched">{{
							'validacao.emailObrigatorio' | translate }}</span>
						<span class="text-danger"
							*ngIf="(emailInput.errors?.['email'] && emailInput.touched) || (error && !emailInput.errors?.['required'])">{{
							'validacao.emailInvalido' | translate }}</span>
					</div>

					<div class="reset-actions">
						<button type="submit" [disabled]="!email || forgotPasswordForm.invalid || isLoading"
							mat-raised-button color="primary" class="auth-submit">
							<mat-icon *ngIf="isLoading" class="spinner">refresh</mat-icon>
							{{ isLoading ? ('login.enviando' | translate) : ('login.enviar' | translate) }}
						</button>
					</div>
				</form>

				<div class="back-to-login">
					{{ 'login.lembrouSenha' | translate }}
					<a class="auth-link" (click)="voltarLogin()">{{ 'login.fazerLogin' | translate }}</a>
				</div>

			</div>
		</div>
	</div>
</div>
